import {getSSRContext} from '@bitstillery/mithril'
import {$s} from '@bitstillery/common/app'

import {portal_path_is_published_cms_route} from '@/cms/lib/route_utils'

/**
 * `$s.page.error` marker for "this path resolves to no published page" — as opposed to the compile /
 * render errors that field otherwise carries, which are developer-facing and must keep their message.
 */
export const PAGE_NOT_FOUND = 'not_found'

/**
 * SSR: answer this request with 404 instead of 200.
 *
 * The portal's route gate (`known_routes.ts`) turns away paths it knows nothing about before any of
 * this runs, so reaching here means the gate said yes and the CMS said no — a page unpublished (or
 * deleted) since the route table was last refreshed. The request is rendered in full, chrome and all;
 * only its status changes. Stashed on the request's SSR context, which `server.ts` reads back once
 * `createSSRResponse` returns (see `context_for_request`).
 */
export function mark_ssr_not_found(): void {
    if (!globalThis.__SSR_MODE__) {
        return
    }
    // Only a surface that IS a published CMS page may 404 on a missing one. `prefetch_cms_page_for_ssr`
    // runs for every non-shop route, so routes that render their own component and merely happen to have
    // no page row behind them (`/cms/preview`) would otherwise turn their own 200 into a 404.
    if (!portal_path_is_published_cms_route($s.env.uri)) {
        return
    }
    const context = getSSRContext()
    if (context) {
        context.http_status = 404
    }
}
